import { ChangeEvent, useEffect, useRef, useState } from "react";
import { ChevronDown } from "react-feather";
import "./styles.css";

interface selectProps {
    name: string;
    label: string;
    returnFunc: (field: string, value: string) => any;
    Valid: boolean;
    setFocus?: boolean;
    excludeQuickFind?: boolean;
    value: string;
    options: { label: string; value: string }[];
    required?: boolean;
}

function Dropdown(props: selectProps) {
    const searchBoxRef = useRef<HTMLInputElement>(null);
    const [fieldValue, setFieldValue] = useState(props.value);
    const [searchVal, setSearchVal] = useState("Search");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [SearchMailbox, setSearchMailbox] = useState(props.options);
    const [placeholder, RemovePlaceholder] = useState("Search");
    let validField = props.Valid;

    const handleSelectChange = (e: React.FormEvent<HTMLSelectElement>) => {
        updateValues(e.currentTarget.value);
    };
    useEffect(() => {
        setFieldValue(props.value);
    }, [props.value]);

    useEffect(() => {
        searchBoxRef.current?.focus();
        if (searchBoxRef.current) {
            searchBoxRef.current.value = searchVal;
        }
    }, [searchVal]);
    const updateValues = (value: string) => {
        setFieldValue(value);
        if (value == "") {
            validField = false;
        } else {
            validField = true;
        }
        props.returnFunc(props.name, value);
    };

    const onOutsideClick = () => {
        setDropdownOpen(false);
        setSearchVal("");
        setSearchMailbox(applyLiOnClick());
    };

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSearchVal(event.target.value);
        if (event.target.value.length > 1) {
            let result = applyLiOnClick().filter((mb: { label: string; value: string }) => {
                const text = mb.label;
                return typeof text === "string" && text.toLowerCase().includes(event.target.value.toLowerCase());
            });
            setSearchMailbox(result);
            searchBoxRef.current?.focus();
        } else {
            searchBoxRef.current?.focus();
            setSearchMailbox(applyLiOnClick());
        }
    };
    const applyLiOnClick = () => {
        //this method closed the dropdown once a selection has been clicked
        let allChildren = props.options.map((x: any) => {
            let child = { ...x.props };
            child.onClick = () => {
                onOutsideClick();
            };
            return { ...x, props: child };
        });
        return allChildren;
    };
    return (
        <div
            className="selectContainer"
            key={"Main" + props.name + Math.random()}
            onMouseLeave={() => onOutsideClick()}
            //
        >
            <div className="col1">
                <label className="g-label">{props.label}</label>
                {props.required == true && <small className="asterisk">*</small>}
            </div>
            <div
                className={"col2"}
                style={{ cursor: "pointer" }}
            >
                <div
                    style={{
                        zIndex: "1000",
                        height: "30px",
                    }}
                >
                    <div
                        style={{ border: "solid 1px #ccc", borderRadius: "2px", height: "26px" }}
                        onClick={() => setDropdownOpen(o => !o)}
                    >
                        <div style={{ float: "left", padding: "3px" }}>
                            {props.options.find(o => o.value === props.value)?.label}
                        </div>
                        <ChevronDown style={{ width: "15px", fontSize: "28px", marginLeft: "10px", float: "right" }}>
                            {" "}
                        </ChevronDown>
                    </div>
                    {dropdownOpen && (
                        <div
                            style={{
                                zIndex: "1000",
                                position: "relative",
                                backgroundColor: "white",
                                top: "-1px",
                                left: "00px",
                                width: "calc (100% - 25px)",
                                border: "solid 1px #ccc",
                                borderTop: "none",
                                padding: "5px",
                            }}
                        >
                            {" "}
                            <input
                                type="text"
                                className={validField ? "g-TextBox-default" : "g-TextBox-default validationFailed"}
                                style={{
                                    marginTop: " 2px",
                                    width: "200px",
                                    marginLeft: "2px",
                                    marginRight: "5px",
                                    fontSize: "11px",
                                    border: "solid 1px #ccc",
                                }}
                                key={"khj"}
                                autoComplete="off"
                                aria-autocomplete="none"
                                list="autocompleteOff"
                                onChange={handleChange}
                                value={searchVal}
                                ref={searchBoxRef}
                                //placeholder={placeholder}
                                //onFocus={e => RemovePlaceholder("")}
                                //onMouseOut={e => RemovePlaceholder("Search")}
                            ></input>
                            <div style={{ maxHeight: "350px", overflowY: "auto" }}>
                                <ul
                                    className="findDropdownUL"
                                    key={props.name + "ul"}
                                >
                                    {SearchMailbox.sort((a, b) => a.label.localeCompare(b.label))
                                        .filter(x => x.label.toLowerCase() !== "please select")
                                        .map((option, index) => (
                                            <li
                                                // key={index}
                                                onClick={() => {
                                                    updateValues(option.value);
                                                    setDropdownOpen(false);
                                                }}
                                            >
                                                {option.label}
                                            </li>
                                        ))}
                                </ul>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
export default Dropdown;
